import {
  GET_RESE_COMMAND_DIVISION_DETAILS,
  RESE_POST_CREATE_JOB,
  RESE_GET_JOB_DETAILS,
  RESET_RESE_CREATE_JOB_SUCCESS_MESSAGE,
  RESET_RESE_MODIFY_JOB_DETAILS,
  GET_RESE_SERVER_DETAILS_BY_JOB_ID,
  CANCEL_RESE_GRAFANA_AGENT_REMOTE_COMMAND_SCHEDULE,
  SET_RESE_MODIFY_JOB_DETAILS,
  SET_RESE_CLONE_JOB_DETAILS,
  RESET_RESE_CLONE_JOB_DETAILS,
} from "./actionTypes";

const initialState = {
  divisionDetails: { serverTypes: null, divisionStores: null },
  divisionDetailsErrorMessage: null,
  createJobSuccessMessage: null,
  createJobErrorMessage: null,
  jobDetails: [],
  jobDetailsErrorMessage: null,
  serverDetailByJobId: [],
  serverDetailByJobIdErrorMessage: null,
  cancelRESECommandScheduleSuccessMessage: null,
  cancelRESECommandScheduleErrorMessage: null,
  setRESEModifyJobDetails: null,
  setCloneJobDetails: null,
};

const reseCommandReducer = (
  state = initialState,
  action = { type: "", payload: null }
) => {
  switch (action.type) {
    case GET_RESE_COMMAND_DIVISION_DETAILS.SUCCESS:
      return {
        ...state,
        divisionDetails: action.payload,
        divisionDetailsErrorMessage: null,
      };
    case GET_RESE_COMMAND_DIVISION_DETAILS.ERROR:
      return {
        ...state,
        divisionDetails: { serverTypes: null, divisionStores: null },
        divisionDetailsErrorMessage: action.payload,
      };

    case RESE_POST_CREATE_JOB.SUCCESS:
      return {
        ...state,
        createJobSuccessMessage: action.payload,
        createJobErrorMessage: null,
      };
    case RESE_POST_CREATE_JOB.ERROR:
      return {
        ...state,
        createJobSuccessMessage: null,
        createJobErrorMessage: action.payload,
      };
    case RESET_RESE_CREATE_JOB_SUCCESS_MESSAGE:
      return {
        ...state,
        createJobSuccessMessage: null,
      };
 
    case RESET_RESE_MODIFY_JOB_DETAILS:
      return {
        ...state,
        setRESEModifyJobDetails: null,
      };
  
    case RESE_GET_JOB_DETAILS.SUCCESS:
      return {
        ...state,
        jobDetails: action.payload,
        jobDetailsErrorMessage: null,
      };
    case RESE_GET_JOB_DETAILS.ERROR:
      return {
        ...state,
        jobDetails: [],
        jobDetailsErrorMessage: action.payload,
      };
    case GET_RESE_SERVER_DETAILS_BY_JOB_ID.SUCCESS:
      return {
        ...state,
        serverDetailByJobId: action.payload,
        serverDetailByJobIdErrorMessage: null,
      };
    case GET_RESE_SERVER_DETAILS_BY_JOB_ID.ERROR:
      return {
        ...state,
        serverDetailByJobId: [],
        serverDetailByJobIdErrorMessage: action.payload,
      };
    case CANCEL_RESE_GRAFANA_AGENT_REMOTE_COMMAND_SCHEDULE.SUCCESS:
      return {
        ...state,
        cancelRESECommandScheduleSuccessMessage: action.payload,
        cancelRESECommandScheduleErrorMessage: null,
      };
    case CANCEL_RESE_GRAFANA_AGENT_REMOTE_COMMAND_SCHEDULE.ERROR:
      return {
        ...state,
        cancelRESECommandScheduleSuccessMessage: null,
        cancelRESECommandScheduleErrorMessage: action.payload,
      };
    case SET_RESE_MODIFY_JOB_DETAILS:
      return {
        ...state,
        setRESEModifyJobDetails: action.payload,
      };
    case SET_RESE_CLONE_JOB_DETAILS:
      return {
        ...state,
        setCloneJobDetails: action.payload,
      };
    case RESET_RESE_CLONE_JOB_DETAILS:
      return {
        ...state,
        setCloneJobDetails: null,
      };
    default:
      return { ...state };
  }
};

export default reseCommandReducer;
